import { useEffect } from 'react';

const usePreventBackNavigation = () => {
  useEffect(() => {
    const handlePopState = () => {
      window.history.forward();
    };

    window.history.pushState(null, window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
};

export default usePreventBackNavigation;
